import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const fontStack = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [channelUrl, setChannelUrl] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (await login(channelUrl, password)) {
      navigate('/admin');
    } else {
      setError('Invalid credentials. Please try again.');
    }
  };

  return (
    <div style={{
      fontFamily: fontStack,
      maxWidth: '400px',
      margin: '0 auto',
      padding: '120px 20px 80px',
      color: '#1a1a1a',
      minHeight: '100vh',
      background: '#fff',
    }}>
      <header style={{ textAlign: 'center', marginBottom: '40px' }}>
        <img
          src="/inquiros-logo.png"
          alt="Inquiros"
          style={{ height: '48px', display: 'block', margin: '0 auto' }}
        />
        <p style={{ fontSize: '0.95rem', color: '#888', marginTop: '6px', fontWeight: 400 }}>
          Admin
        </p>
      </header>

      <form
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '28px',
          borderRadius: '12px',
          border: '1px solid #eee',
        }}
      >
        <input
          type="text"
          name="channelURL"
          placeholder="Channel URL"
          value={channelUrl}
          onChange={(e) => setChannelUrl(e.target.value)}
          required
          style={{
            width: '100%',
            padding: '10px 12px',
            fontSize: '0.9rem',
            fontFamily: fontStack,
            borderRadius: '8px',
            border: '1px solid #eee',
            background: '#fafafa',
            color: '#1a1a1a',
            outline: 'none',
            boxSizing: 'border-box',
            marginBottom: '12px',
          }}
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{
            width: '100%',
            padding: '10px 12px',
            fontSize: '0.9rem',
            fontFamily: fontStack,
            borderRadius: '8px',
            border: '1px solid #eee',
            background: '#fafafa',
            color: '#1a1a1a',
            outline: 'none',
            boxSizing: 'border-box',
            marginBottom: '20px',
          }}
        />
        <button
          type="submit"
          style={{
            width: '100%',
            padding: '10px 24px',
            fontSize: '0.875rem',
            fontFamily: fontStack,
            fontWeight: 500,
            backgroundColor: '#111',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'opacity 0.15s ease',
          }}
        >
          Login
        </button>
        {error && (
          <p style={{ marginTop: '14px', textAlign: 'center', fontSize: '0.85rem', color: '#dc2626' }}>
            {error}
          </p>
        )}
      </form>
    </div>
  );
}

export default Login;
